import React from 'react';
import PropTypes from 'prop-types';
import './database_row.scss';

const DatabaseRow = ({ name, editPath }) => {
  return (
    <div className="database-row">
      <div className="database-row__database-name">
        { name }
      </div>
      <div className="database-row__edit-link">
        <a href={editPath}>Settings</a>
      </div>
    </div>
  );
};

DatabaseRow.propTypes = {
  editPath: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};

export default DatabaseRow;
